import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
const MAX_NAMES = 3;

export const periodColumn = (
  header: string,
): ColumnDef<EnrichedProfitabilityPeriod> => ({
  id: "period",
  header,
  // Sorted on the ISO date, not the rendered label: "Dec 01" sorts before
  accessorFn: (row) => row.start_date ?? row.display.period,
  meta: { size: "220px" },
  cell: ({ row }) => (
    <Stack gap={0} align="stretch" className="min-w-0 py-2">
      {row.original.start_date || !row.original.documents?.length ? (
        <span className="font-medium">{row.original.display.period}</span>
      ) : (
        <>
          {row.original.documents.slice(0, MAX_NAMES).map((document) => (
            <span
              key={document.id}
              className="truncate font-medium"
              title={document.file_name}
            >
              {document.file_name}
            </span>
          ))}
          {row.original.documents.length > MAX_NAMES && (
            <span className="text-xs text-subtle">
              +{row.original.documents.length - MAX_NAMES} more
            </span>
          )}
        </>
      )}
      <span className="text-xs text-subtle">{row.original.display.span}</span>
    </Stack>
  ),
});
